import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
  Box,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Avatar,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Stack,
  Tooltip,
  LinearProgress,
  Divider,
  FormControlLabel,
  Switch,
  FormHelperText
} from '@mui/material';
import {
  DirectionsCar,
  Add,
  LocationOn,
  Speed,
  LocalGasStation,
  QrCode2,
  Edit,
  Delete,
  Badge,
  Info,
  CalendarToday,
  Build,
  Warning,
  CheckCircle,
  AttachMoney,
  Person,
  Assignment,
  History,
  TrendingUp,
  Refresh,
  FilterList,
  Search
} from '@mui/icons-material';

function Vehicles() {
  const [vehicles, setVehicles] = useState([
    {
      id: 1,
      name: 'Renault Master',
      plate: 'AB-123-CD',
      type: 'Utilitaire',
      vehicleCategory: 'VU', // VP ou VU
      status: 'available',
      fuel: 75,
      km: 45231,
      location: 'Parking A',
      lastMaintenance: '2025-10-15',
      nextMaintenance: '2025-12-15',
      lastCT: '2024-09-15',
      nextCT: '2026-09-15',
      ctResult: 'Favorable',
      ctCenter: 'Autosur Saint-Denis',
      ctCost: 75,
      lastPollution: '2025-09-20',
      nextPollution: '2026-09-20',
      pollutionResult: 'Favorable',
      insurance: 'AXA - Exp: 2025-12-31',
      assignedTo: null,
      yearlyKm: 12500,
      avgConsumption: 8.5,
      totalCost: 3250
    },
    {
      id: 2,
      name: 'Peugeot Partner',
      plate: 'EF-456-GH',
      type: 'Utilitaire',
      vehicleCategory: 'VU',
      status: 'in_use',
      fuel: 40,
      km: 78456,
      location: 'En mission - Résidence Les Palmiers',
      lastMaintenance: '2025-09-20',
      nextMaintenance: '2025-11-20',
      lastCT: '2023-11-10',
      nextCT: '2025-11-10',
      ctResult: 'Favorable',
      ctCenter: 'Dekra Saint-Pierre',
      ctCost: 68,
      lastPollution: '2024-11-15',
      nextPollution: '2025-11-15',
      pollutionResult: 'Favorable',
      insurance: 'MAIF - Exp: 2026-03-15',
      assignedTo: 'Jean Dupont',
      yearlyKm: 18200,
      avgConsumption: 7.2,
      totalCost: 4180
    },
    {
      id: 3,
      name: 'Citroën Berlingo',
      plate: 'IJ-789-KL',
      type: 'Utilitaire',
      vehicleCategory: 'VU',
      status: 'maintenance',
      fuel: 20,
      km: 120456,
      location: 'Garage Central',
      lastMaintenance: '2025-11-10',
      nextMaintenance: '2025-11-25',
      lastCT: '2024-03-20',
      nextCT: '2026-03-20',
      ctResult: 'Favorable',
      ctCenter: 'Autovision Saint-Denis',
      ctCost: 72,
      lastPollution: '2025-03-25',
      nextPollution: '2026-03-25',
      pollutionResult: 'Favorable',
      insurance: 'GMF - Exp: 2025-11-30',
      assignedTo: null,
      yearlyKm: 22000,
      avgConsumption: 6.8,
      totalCost: 5420
    }
  ]);
  
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openAssignDialog, setOpenAssignDialog] = useState(false);
  const [openMaintenanceDialog, setOpenMaintenanceDialog] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [employees, setEmployees] = useState([]);
  
  // Form states
  const [vehicleType, setVehicleType] = useState('');
  const [plate, setPlate] = useState('');
  const [newVehicle, setNewVehicle] = useState({
    name: '',
    type: '',
    km: 0,
    fuel: 100,
    location: '',
    insurance: ''
  });

  useEffect(() => {
    loadEmployees();
  }, []);

  const loadEmployees = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/users', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const usersList = data.users || data || [];
        // Filtrer uniquement les employés
        const employeesList = usersList.filter(user => user.isEmployee === true);
        setEmployees(employeesList);
      }
    } catch (error) {
      console.error('Erreur chargement employés:', error);
    }
  };

  // Calculer le niveau d'alerte pour le CT
  const getCTAlert = (nextCTDate) => {
    if (!nextCTDate) return null;
    const today = new Date();
    const ctDate = new Date(nextCTDate);
    const diffTime = ctDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return { level: 'error', message: 'CT DÉPASSÉ !', color: 'error' };
    if (diffDays <= 30) return { level: 'error', message: `CT dans ${diffDays} jours`, color: 'error' };
    if (diffDays <= 60) return { level: 'warning', message: `CT dans ${diffDays} jours`, color: 'warning' };
    return { level: 'ok', message: `CT OK`, color: 'success' };
  };

  const vehicleTypes = [
    'Utilitaire',
    'Voiture particulière',
    'Camionnette',
    'Monospace',
    'Berline',
    'SUV',
    'Fourgon',
    'Minibus',
    'Camping-car'
  ];

  // Fonction pour formater la plaque d'immatriculation
  const formatPlate = (value) => {
    let cleaned = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    let formatted = '';
    if (cleaned.length > 0) {
      formatted = cleaned.substring(0, 2);
    }
    if (cleaned.length > 2) {
      formatted += '-' + cleaned.substring(2, 5);
    }
    if (cleaned.length > 5) {
      formatted += '-' + cleaned.substring(5, 7);
    }
    return formatted;
  };

  const handlePlateChange = (e) => {
    const value = e.target.value;
    const formatted = formatPlate(value);
    setPlate(formatted);
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'available': return 'success';
      case 'in_use': return 'warning';
      case 'maintenance': return 'error';
      case 'out_of_service': return 'default';
      default: return 'default';
    }
  };

  const getStatusLabel = (status) => {
    switch(status) {
      case 'available': return 'Disponible';
      case 'in_use': return 'En utilisation';
      case 'maintenance': return 'En maintenance';
      case 'out_of_service': return 'Hors service';
      default: return status;
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'available': return <CheckCircle />;
      case 'in_use': return <Person />;
      case 'maintenance': return <Build />;
      case 'out_of_service': return <Warning />;
      default: return <DirectionsCar />;
    }
  };

  // Calculer les statistiques
  const stats = {
    total: vehicles.length,
    available: vehicles.filter(v => v.status === 'available').length,
    inUse: vehicles.filter(v => v.status === 'in_use').length,
    maintenance: vehicles.filter(v => v.status === 'maintenance').length,
    avgKm: Math.round(vehicles.reduce((sum, v) => sum + v.km, 0) / vehicles.length),
    avgFuel: Math.round(vehicles.reduce((sum, v) => sum + v.fuel, 0) / vehicles.length),
    totalCost: vehicles.reduce((sum, v) => sum + v.totalCost, 0)
  };

  // Filtrer les véhicules
  const filteredVehicles = vehicles.filter(v => {
    const matchStatus = filterStatus === 'all' || v.status === filterStatus;
    const matchSearch = v.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                       v.plate.toLowerCase().includes(searchTerm.toLowerCase());
    return matchStatus && matchSearch;
  });

  // Ouvrir le dialogue d'affectation
  const handleAssignVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    setOpenAssignDialog(true);
  };

  // Ouvrir le dialogue de maintenance
  const handleMaintenanceDialog = (vehicle) => {
    setSelectedVehicle(vehicle);
    setOpenMaintenanceDialog(true);
  };

  // Ouvrir le dialogue d'édition
  const handleEditVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    setPlate(vehicle.plate);
    setVehicleType(vehicle.type);
    setOpenEditDialog(true);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56 }}>
            <DirectionsCar fontSize="large" />
          </Avatar>
          <Typography variant="h4">
            Gestion du Parc Automobile
          </Typography>
        </Stack>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setOpenDialog(true)}
          size="large"
        >
          Ajouter un véhicule
        </Button>
      </Box>

      {/* Statistiques globales */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography color="textSecondary" variant="body2">
                    Total véhicules
                  </Typography>
                  <Typography variant="h4">{stats.total}</Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'primary.light' }}>
                  <DirectionsCar color="primary" />
                </Avatar>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography color="textSecondary" variant="body2">
                    Disponibles
                  </Typography>
                  <Typography variant="h4" color="success.main">{stats.available}</Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'success.light' }}>
                  <CheckCircle color="success" />
                </Avatar>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography color="textSecondary" variant="body2">
                    En utilisation
                  </Typography>
                  <Typography variant="h4" color="warning.main">{stats.inUse}</Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'warning.light' }}>
                  <Person color="warning" />
                </Avatar>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography color="textSecondary" variant="body2">
                    Coûts annuels
                  </Typography>
                  <Typography variant="h4">{stats.totalCost.toLocaleString()}€</Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'info.light' }}>
                  <AttachMoney color="info" />
                </Avatar>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filtres et recherche */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder="Rechercher par nom ou plaque..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Filtrer par statut</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="Filtrer par statut"
                startAdornment={
                  <InputAdornment position="start">
                    <FilterList />
                  </InputAdornment>
                }
              >
                <MenuItem value="all">Tous les véhicules</MenuItem>
                <MenuItem value="available">Disponibles</MenuItem>
                <MenuItem value="in_use">En utilisation</MenuItem>
                <MenuItem value="maintenance">En maintenance</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<Refresh />}
              onClick={() => { setSearchTerm(''); setFilterStatus('all'); }}
            >
              Réinitialiser
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Onglets */}
      <Paper sx={{ mb: 2 }}>
        <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
          <Tab label="Vue Cartes" icon={<DirectionsCar />} iconPosition="start" />
          <Tab label="Vue Liste" icon={<Assignment />} iconPosition="start" />
          <Tab label="Maintenances" icon={<Build />} iconPosition="start" />
          <Tab label="Contrôles Techniques" icon={<CheckCircle />} iconPosition="start" />
        </Tabs>
      </Paper>

      {/* Vue Cartes */}
      {tabValue === 0 && (
        <Grid container spacing={3}>
          {filteredVehicles.map((vehicle) => (
            <Grid item xs={12} md={6} lg={4} key={vehicle.id}>
              <Card elevation={3} sx={{ height: '100%' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48 }}>
                      {getStatusIcon(vehicle.status)}
                    </Avatar>
                    <Chip
                      label={getStatusLabel(vehicle.status)}
                      color={getStatusColor(vehicle.status)}
                      size="small"
                    />
                  </Box>
                  
                  <Typography variant="h6" gutterBottom fontWeight="bold">
                    {vehicle.name}
                  </Typography>
                  <Chip label={vehicle.plate} size="small" sx={{ mb: 2 }} />
                  
                  <Divider sx={{ my: 2 }} />

                  <Stack spacing={1.5}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Speed sx={{ mr: 1, fontSize: 20, color: 'text.secondary' }} />
                        <Typography variant="body2">{vehicle.km.toLocaleString()} km</Typography>
                      </Box>
                      <Typography variant="caption" color="text.secondary">
                        {vehicle.yearlyKm.toLocaleString()} km/an
                      </Typography>
                    </Box>
                    
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <LocalGasStation sx={{ mr: 1, fontSize: 20, color: 'text.secondary' }} />
                        <Typography variant="body2">{vehicle.fuel}% carburant</Typography>
                      </Box>
                      <LinearProgress 
                        variant="determinate" 
                        value={vehicle.fuel} 
                        sx={{ height: 6, borderRadius: 1 }}
                        color={vehicle.fuel > 50 ? 'success' : vehicle.fuel > 20 ? 'warning' : 'error'}
                      />
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <LocationOn sx={{ mr: 1, fontSize: 20, color: 'text.secondary' }} />
                      <Typography variant="body2">{vehicle.location}</Typography>
                    </Box>

                    {vehicle.assignedTo && (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Person sx={{ mr: 1, fontSize: 20, color: 'primary.main' }} />
                        <Typography variant="body2" color="primary">
                          {vehicle.assignedTo}
                        </Typography>
                      </Box>
                    )}

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <CalendarToday sx={{ mr: 1, fontSize: 20, color: 'text.secondary' }} />
                      <Typography variant="caption" color="text.secondary">
                        Prochain entretien: {new Date(vehicle.nextMaintenance).toLocaleDateString('fr-FR')}
                      </Typography>
                    </Box>

                    {/* Alerte Contrôle Technique */}
                    {(() => {
                      const alert = getCTAlert(vehicle.nextCT);
                      return alert && alert.level !== 'ok' && (
                        <Alert severity={alert.color} sx={{ mt: 1.5 }} icon={<Warning />}>
                          <Typography variant="caption" fontWeight="bold">
                            {alert.message}
                          </Typography>
                          <Typography variant="caption" display="block">
                            CT prévu: {new Date(vehicle.nextCT).toLocaleDateString('fr-FR')}
                          </Typography>
                        </Alert>
                      );
                    })()}
                  </Stack>
                </CardContent>
                
                <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                  <Stack direction="row" spacing={1}>
                    <Tooltip title="Affecter">
                      <IconButton 
                        size="small" 
                        color="primary"
                        onClick={() => handleAssignVehicle(vehicle)}
                      >
                        <Person />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Maintenance">
                      <IconButton 
                        size="small" 
                        color="warning"
                        onClick={() => handleMaintenanceDialog(vehicle)}
                      >
                        <Build />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Modifier">
                      <IconButton size="small" onClick={() => handleEditVehicle(vehicle)}>
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                  <Button size="small" startIcon={<QrCode2 />}>
                    QR Code
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Vue Liste */}
      {tabValue === 1 && (
        <TableContainer component={Paper} elevation={2}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Véhicule</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Statut</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Kilométrage</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Carburant</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Affecté à</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Emplacement</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredVehicles.map((vehicle) => (
                <TableRow key={vehicle.id} hover>
                  <TableCell>
                    <Box>
                      <Typography variant="body2" fontWeight="medium">{vehicle.name}</Typography>
                      <Typography variant="caption" color="text.secondary">{vehicle.plate}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={getStatusLabel(vehicle.status)}
                      color={getStatusColor(vehicle.status)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{vehicle.km.toLocaleString()} km</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <LinearProgress 
                        variant="determinate" 
                        value={vehicle.fuel} 
                        sx={{ width: 60, height: 6 }}
                        color={vehicle.fuel > 50 ? 'success' : vehicle.fuel > 20 ? 'warning' : 'error'}
                      />
                      <Typography variant="caption">{vehicle.fuel}%</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{vehicle.assignedTo || '-'}</TableCell>
                  <TableCell>{vehicle.location}</TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={0.5}>
                      <Tooltip title="Affecter">
                        <IconButton size="small" onClick={() => handleAssignVehicle(vehicle)}>
                          <Person fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Maintenance">
                        <IconButton size="small" onClick={() => handleMaintenanceDialog(vehicle)}>
                          <Build fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Modifier">
                        <IconButton size="small" onClick={() => handleEditVehicle(vehicle)}>
                          <Edit fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Vue Maintenances */}
      {tabValue === 2 && (
        <Grid container spacing={2}>
          {filteredVehicles.map((vehicle) => (
            <Grid item xs={12} key={vehicle.id}>
              <Card elevation={2}>
                <CardContent>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={3}>
                      <Typography variant="h6">{vehicle.name}</Typography>
                      <Typography variant="caption" color="text.secondary">{vehicle.plate}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="body2" color="text.secondary">Dernier entretien</Typography>
                      <Typography variant="body1">
                        {new Date(vehicle.lastMaintenance).toLocaleDateString('fr-FR')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="body2" color="text.secondary">Prochain entretien</Typography>
                      <Typography variant="body1" color="warning.main">
                        {new Date(vehicle.nextMaintenance).toLocaleDateString('fr-FR')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<Build />}
                        onClick={() => handleMaintenanceDialog(vehicle)}
                      >
                        Planifier
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Vue Contrôles Techniques */}
      {tabValue === 3 && (
        <Grid container spacing={2}>
          {filteredVehicles.map((vehicle) => {
            const ctAlert = getCTAlert(vehicle.nextCT);
            const pollutionAlert = vehicle.vehicleCategory === 'VU' ? getCTAlert(vehicle.nextPollution) : null;
            
            return (
              <Grid item xs={12} key={vehicle.id}>
                <Card elevation={2}>
                  <CardContent>
                    <Grid container spacing={2} alignItems="center">
                      {/* Infos véhicule */}
                      <Grid item xs={12} md={2}>
                        <Typography variant="h6">{vehicle.name}</Typography>
                        <Typography variant="caption" color="text.secondary">{vehicle.plate}</Typography>
                        <Chip 
                          label={vehicle.vehicleCategory} 
                          size="small" 
                          sx={{ mt: 0.5 }}
                          color={vehicle.vehicleCategory === 'VU' ? 'warning' : 'default'}
                        />
                      </Grid>

                      {/* Contrôle Technique */}
                      <Grid item xs={12} md={4}>
                        <Paper sx={{ p: 2, bgcolor: ctAlert?.color === 'error' ? 'error.light' : ctAlert?.color === 'warning' ? 'warning.light' : 'success.light' }}>
                          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                            <CheckCircle />
                            <Typography variant="subtitle2" fontWeight="bold">
                              Contrôle Technique
                            </Typography>
                          </Stack>
                          <Typography variant="caption" color="text.secondary">Dernier CT: </Typography>
                          <Typography variant="body2">
                            {new Date(vehicle.lastCT).toLocaleDateString('fr-FR')}
                            <Chip label={vehicle.ctResult} size="small" color="success" sx={{ ml: 1 }} />
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                            Prochain CT:
                          </Typography>
                          <Typography variant="body1" fontWeight="bold" color={ctAlert?.color === 'error' ? 'error.main' : ctAlert?.color === 'warning' ? 'warning.main' : 'success.main'}>
                            {new Date(vehicle.nextCT).toLocaleDateString('fr-FR')}
                          </Typography>
                          {ctAlert && ctAlert.level !== 'ok' && (
                            <Alert severity={ctAlert.color} sx={{ mt: 1 }}>
                              {ctAlert.message}
                            </Alert>
                          )}
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                            Centre: {vehicle.ctCenter} • Coût: {vehicle.ctCost}€
                          </Typography>
                        </Paper>
                      </Grid>

                      {/* Contrôle Antipollution (si VU) */}
                      {vehicle.vehicleCategory === 'VU' && (
                        <Grid item xs={12} md={4}>
                          <Paper sx={{ p: 2, bgcolor: pollutionAlert?.color === 'error' ? 'error.light' : pollutionAlert?.color === 'warning' ? 'warning.light' : 'success.light' }}>
                            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                              <Warning />
                              <Typography variant="subtitle2" fontWeight="bold">
                                Contrôle Antipollution
                              </Typography>
                            </Stack>
                            <Typography variant="caption" color="text.secondary">Dernier contrôle: </Typography>
                            <Typography variant="body2">
                              {new Date(vehicle.lastPollution).toLocaleDateString('fr-FR')}
                              <Chip label={vehicle.pollutionResult} size="small" color="success" sx={{ ml: 1 }} />
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                              Prochain contrôle:
                            </Typography>
                            <Typography variant="body1" fontWeight="bold" color={pollutionAlert?.color === 'error' ? 'error.main' : pollutionAlert?.color === 'warning' ? 'warning.main' : 'success.main'}>
                              {new Date(vehicle.nextPollution).toLocaleDateString('fr-FR')}
                            </Typography>
                            {pollutionAlert && pollutionAlert.level !== 'ok' && (
                              <Alert severity={pollutionAlert.color} sx={{ mt: 1 }}>
                                {pollutionAlert.message}
                              </Alert>
                            )}
                          </Paper>
                        </Grid>
                      )}

                      {/* Actions */}
                      <Grid item xs={12} md={vehicle.vehicleCategory === 'VU' ? 2 : 6}>
                        <Stack spacing={1}>
                          <Button
                            fullWidth
                            variant="contained"
                            startIcon={<CalendarToday />}
                            size="small"
                          >
                            Planifier CT
                          </Button>
                          {vehicle.vehicleCategory === 'VU' && (
                            <Button
                              fullWidth
                              variant="outlined"
                              startIcon={<CalendarToday />}
                              size="small"
                            >
                              Planifier Pollution
                            </Button>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}

      {/* Dialog Ajout véhicule */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar sx={{ bgcolor: 'primary.main' }}>
              <Add />
            </Avatar>
            <Typography variant="h6">Ajouter un véhicule</Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField 
              fullWidth 
              label="Nom du véhicule" 
              placeholder="Ex: Renault Master"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <DirectionsCar />
                  </InputAdornment>
                ),
              }}
            />
            <TextField 
              fullWidth 
              label="Immatriculation" 
              value={plate}
              onChange={handlePlateChange}
              inputProps={{
                maxLength: 9
              }}
              helperText="Format: XX-XXX-XX"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Badge />
                  </InputAdornment>
                ),
              }}
            />
            <FormControl fullWidth>
              <InputLabel>Type de véhicule</InputLabel>
              <Select
                value={vehicleType}
                onChange={(e) => setVehicleType(e.target.value)}
                label="Type de véhicule"
                startAdornment={
                  <InputAdornment position="start">
                    <Info sx={{ mr: 1 }} />
                  </InputAdornment>
                }
              >
                {vehicleTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField 
              fullWidth 
              label="Kilométrage actuel" 
              type="number" 
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Speed />
                  </InputAdornment>
                ),
              }}
            />
            <TextField 
              fullWidth 
              label="Emplacement actuel" 
              placeholder="Ex: Parking A"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocationOn />
                  </InputAdornment>
                ),
              }}
            />
            <TextField 
              fullWidth 
              label="Assurance" 
              placeholder="Ex: AXA - Exp: 2025-12-31"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Assignment />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => { setOpenDialog(false); setPlate(''); }}>
            Annuler
          </Button>
          <Button variant="contained" startIcon={<Add />}>
            Ajouter le véhicule
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Affectation véhicule */}
      <Dialog open={openAssignDialog} onClose={() => setOpenAssignDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Affecter le véhicule
          {selectedVehicle && (
            <Typography variant="body2" color="text.secondary">
              {selectedVehicle.name} - {selectedVehicle.plate}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Technicien</InputLabel>
              <Select label="Technicien">
                <MenuItem value="">Aucun (libérer le véhicule)</MenuItem>
                {employees.map((emp) => (
                  <MenuItem key={emp.id} value={emp.id}>
                    {emp.firstName} {emp.lastName} - {emp.role}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Mission / Intervention"
              placeholder="Ex: Résidence Les Palmiers"
              multiline
              rows={2}
            />
            <TextField
              fullWidth
              type="datetime-local"
              label="Début de la mission"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              fullWidth
              type="datetime-local"
              label="Retour prévu"
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAssignDialog(false)}>Annuler</Button>
          <Button variant="contained">Affecter</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Modification véhicule */}
      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar sx={{ bgcolor: 'primary.main' }}>
              <Edit />
            </Avatar>
            <Box>
              <Typography variant="h6">Modifier le véhicule</Typography>
              {selectedVehicle && (
                <Typography variant="body2" color="text.secondary">
                  {selectedVehicle.name} - {selectedVehicle.plate}
                </Typography>
              )}
            </Box>
          </Stack>
        </DialogTitle>
        <DialogContent>
          {selectedVehicle && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
              <TextField 
                fullWidth 
                label="Nom du véhicule" 
                defaultValue={selectedVehicle.name}
                placeholder="Ex: Renault Master"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DirectionsCar />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField 
                fullWidth 
                label="Immatriculation" 
                value={plate}
                onChange={handlePlateChange}
                inputProps={{
                  maxLength: 9
                }}
                helperText="Format: XX-XXX-XX"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Badge />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl fullWidth>
                <InputLabel>Type de véhicule</InputLabel>
                <Select
                  value={vehicleType}
                  onChange={(e) => setVehicleType(e.target.value)}
                  label="Type de véhicule"
                  startAdornment={
                    <InputAdornment position="start">
                      <Info sx={{ mr: 1 }} />
                    </InputAdornment>
                  }
                >
                  {vehicleTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField 
                fullWidth 
                label="Kilométrage actuel" 
                type="number"
                defaultValue={selectedVehicle.km}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Speed />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField 
                fullWidth 
                label="Niveau de carburant (%)" 
                type="number"
                defaultValue={selectedVehicle.fuel}
                inputProps={{ min: 0, max: 100 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocalGasStation />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField 
                fullWidth 
                label="Emplacement actuel" 
                defaultValue={selectedVehicle.location}
                placeholder="Ex: Parking A"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOn />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField 
                fullWidth 
                label="Assurance" 
                defaultValue={selectedVehicle.insurance}
                placeholder="Ex: AXA - Exp: 2025-12-31"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Assignment />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl fullWidth>
                <InputLabel>Statut</InputLabel>
                <Select
                  defaultValue={selectedVehicle.status}
                  label="Statut"
                >
                  <MenuItem value="available">Disponible</MenuItem>
                  <MenuItem value="in_use">En utilisation</MenuItem>
                  <MenuItem value="maintenance">En maintenance</MenuItem>
                  <MenuItem value="out_of_service">Hors service</MenuItem>
                </Select>
              </FormControl>

              <Divider sx={{ my: 2 }}>
                <Chip label="Contrôle Technique" icon={<CheckCircle />} />
              </Divider>

              <FormControl fullWidth>
                <InputLabel>Catégorie véhicule</InputLabel>
                <Select
                  defaultValue={selectedVehicle.vehicleCategory}
                  label="Catégorie véhicule"
                >
                  <MenuItem value="VP">Véhicule Particulier (VP)</MenuItem>
                  <MenuItem value="VU">Véhicule Utilitaire (VU) - Contrôle pollution obligatoire</MenuItem>
                </Select>
                <FormHelperText>
                  VU = Contrôle technique + Contrôle antipollution annuel
                </FormHelperText>
              </FormControl>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField 
                    fullWidth 
                    label="Date dernier CT" 
                    type="date"
                    defaultValue={selectedVehicle.lastCT}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField 
                    fullWidth 
                    label="Date prochain CT" 
                    type="date"
                    defaultValue={selectedVehicle.nextCT}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Résultat CT</InputLabel>
                    <Select
                      defaultValue={selectedVehicle.ctResult}
                      label="Résultat CT"
                    >
                      <MenuItem value="Favorable">Favorable</MenuItem>
                      <MenuItem value="Défavorable">Défavorable</MenuItem>
                      <MenuItem value="Contre-visite">Contre-visite</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField 
                    fullWidth 
                    label="Coût CT" 
                    type="number"
                    defaultValue={selectedVehicle.ctCost}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">€</InputAdornment>
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Centre de contrôle" 
                    defaultValue={selectedVehicle.ctCenter}
                    placeholder="Ex: Autosur Saint-Denis"
                  />
                </Grid>
              </Grid>

              {selectedVehicle.vehicleCategory === 'VU' && (
                <>
                  <Divider sx={{ my: 2 }}>
                    <Chip label="Contrôle Antipollution (VU uniquement)" icon={<Warning />} color="warning" />
                  </Divider>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField 
                        fullWidth 
                        label="Date dernier contrôle pollution" 
                        type="date"
                        defaultValue={selectedVehicle.lastPollution}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField 
                        fullWidth 
                        label="Date prochain contrôle pollution" 
                        type="date"
                        defaultValue={selectedVehicle.nextPollution}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Résultat contrôle pollution</InputLabel>
                        <Select
                          defaultValue={selectedVehicle.pollutionResult}
                          label="Résultat contrôle pollution"
                        >
                          <MenuItem value="Favorable">Favorable</MenuItem>
                          <MenuItem value="Défavorable">Défavorable</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => { setOpenEditDialog(false); setPlate(''); }}>
            Annuler
          </Button>
          <Button variant="contained" startIcon={<Edit />}>
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Maintenance */}
      <Dialog open={openMaintenanceDialog} onClose={() => setOpenMaintenanceDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar sx={{ bgcolor: 'warning.main' }}>
              <Build />
            </Avatar>
            <Box>
              <Typography variant="h6">Planifier une maintenance</Typography>
              {selectedVehicle && (
                <Typography variant="body2" color="text.secondary">
                  {selectedVehicle.name} - {selectedVehicle.plate}
                </Typography>
              )}
            </Box>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Type de maintenance</InputLabel>
              <Select label="Type de maintenance">
                <MenuItem value="revision">Révision générale</MenuItem>
                <MenuItem value="vidange">Vidange</MenuItem>
                <MenuItem value="pneus">Changement pneus</MenuItem>
                <MenuItem value="ct">Contrôle technique</MenuItem>
                <MenuItem value="reparation">Réparation</MenuItem>
                <MenuItem value="autre">Autre</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth
              type="date"
              label="Date prévue"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              fullWidth
              label="Garage / Prestataire"
              placeholder="Ex: Garage Central"
            />
            <TextField
              fullWidth
              label="Coût estimé"
              type="number"
              InputProps={{
                startAdornment: <InputAdornment position="start">€</InputAdornment>
              }}
            />
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Notes / Observations"
              placeholder="Détails de l'intervention..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMaintenanceDialog(false)}>Annuler</Button>
          <Button variant="contained" startIcon={<CalendarToday />}>
            Planifier
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Vehicles;